<template>
  <div class="total-retailers group flex space-x-4 px-4 py-3.5 mx-2 rounded-lg items-center cursor-pointer text-expressgray hover:bg-express hover:bg-opacity-10 hover:text-express transition-colors">
    <span class="flex items-center justify-center w-9 h-9 rounded-lg bg-express bg-opacity-10 text-express group-hover:bg-opacity-20 transition-colors flex-shrink-0">
      <i :class="iconclass" class="text-center text-base"></i>
    </span>
    <p class="font-semibold text-base">{{ title }}</p>
  </div>
</template>

<script>
export default {
  name: "menuitems",
  props:["iconclass", "title"]
}
</script>

<style scoped>

</style>
